var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loader},[_c('svg',{class:_vm.$style.circular,attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{class:_vm.$style.path,attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"2","stroke-miterlimit":"10"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }